import { Divider, IconButton, ListItemIcon, ListSubheader, Menu, MenuItem } from "@mui/material";
import Archive from "@mui/icons-material/Archive";
import Check from "@mui/icons-material/Check";
import LinkIcon from "@mui/icons-material/Link";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import { useState } from "react";
import { teamName, useWorkspace } from "../../../misc/Workspace";
import { panelFontSize } from "./PanelSection";

const menuSlotProps = {
    paper: { sx: { minWidth: 200, "& .MuiMenuItem-root": { fontSize: panelFontSize, minHeight: 32 } } },
};

// TaskPanelMenu holds what a task needs now and then: its team, a link to it, and
// archive. A task that isn't saved yet has no link and nothing to archive.
export function TaskPanelMenu(props: {
    team: number;
    disabled?: boolean;

    // hideTeam leaves the team out, for a checklist item, which is on its parent's team
    hideTeam?: boolean;
    onTeam: (team: number) => void;

    onCopyLink?: () => void;
    onArchive?: () => void;
}) {
    const ws = useWorkspace();
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);

    const run = (action: () => void) => () => {
        setAnchor(null);
        action();
    };

    return (
        <>
            <IconButton size="small" aria-label="Task menu" disabled={props.disabled}
                        onClick={e => setAnchor(e.currentTarget)}
                        // reaches into the panel's gutter, in line with the close button above
                        sx={{ flexShrink: 0, mt: 0.5, mr: -2 }}>
                <MoreHoriz fontSize="small" />
            </IconButton>

            <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)} slotProps={menuSlotProps}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}>
                {!props.hideTeam && [
                    <ListSubheader key="team" sx={{ lineHeight: "32px", fontSize: 11 }}>Team</ListSubheader>,
                    ...ws.teams.map(row => (
                        <MenuItem key={row.id} selected={row.id === props.team}
                                  onClick={run(() => {
                                      if (row.id !== props.team) props.onTeam(row.id);
                                  })}>
                            <ListItemIcon>{row.id === props.team && <Check fontSize="small" />}</ListItemIcon>
                            {teamName(row, row.id)}
                        </MenuItem>
                    )),
                ]}

                {!props.hideTeam && (props.onCopyLink || props.onArchive) && <Divider />}

                {props.onCopyLink && (
                    <MenuItem onClick={run(props.onCopyLink)}>
                        <ListItemIcon><LinkIcon fontSize="small" /></ListItemIcon>
                        Copy permalink
                    </MenuItem>
                )}

                {props.onArchive && (
                    <MenuItem onClick={run(props.onArchive)}>
                        <ListItemIcon><Archive fontSize="small" /></ListItemIcon>
                        Archive
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}
